import { render, staticRenderFns } from "./AddBankCard.vue?vue&type=template&id=103456c9&scoped=true"
import script from "./AddBankCard.vue?vue&type=script&lang=js"
export * from "./AddBankCard.vue?vue&type=script&lang=js"
import style0 from "./AddBankCard.vue?vue&type=style&index=0&id=103456c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103456c9",
  null
  
)

export default component.exports